<div class="dwo-card" *ngIf="demandDetails !== null">
  <div class="row">
    <form
      [formGroup]="editDwoDiagnoseForm"
      (ngSubmit)="onSave(editDwoDiagnoseForm.value)" class="w-100"
    >
      <div [formGroupName]="formName">
        <div class="row">
          <div class="col-6 col-lg-3">
            <div class="af-form-group">
              <label translate>lblDiagnose</label>
              <div class="lbl-info">
                <ng-select
                  [clearable]="false"
                  [(ngModel)]="diagnose"
                  formControlName="diagnoseName"
                  [searchable]="false"
                  (change)="changeDiagonseText($event)"
                >
                  <ng-option
                    selected
                    translate
                    [value]="diagnose.id"
                    *ngFor="let diagnose of service.DiagnoseList"
                    >{{ diagnose.name }}
                  </ng-option>
                </ng-select>
                <div class="mt-2 comment">
                  <textarea
                    class="form-control customize-textbox"
                    cols="30"
                    rows="5"
                    formControlName="diagnoseText"
                  ></textarea>
                </div>
                
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="af-form-group">
              <label translate>lblCause</label>
              <div class="lbl-info">
                <ng-select
                  [clearable]="false"
                  formControlName="causeName"
                  [searchable]="false"
                  (change)="changeCauseText($event)"
                >
                  <ng-option
                    selected
                    translate
                    [value]="cause.id"
                    *ngFor="let cause of service.CauseList"
                    >{{ cause.name }}
                  </ng-option>
                </ng-select>
                <div class="mt-2 comment">
                  <textarea
                    class="form-control customize-textbox"
                    cols="30"
                    rows="5"
                    formControlName="causeText"
                  ></textarea>
                </div>
                
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="af-form-group">
              <label translate>lblSolutionAndResult</label>
              <div class="lbl-info">
                <ng-select
                  [clearable]="false"
                  formControlName="reasonName"
                  [searchable]="false"
                  (change)="changeReasonText($event)"
                >
                  <ng-option
                    selected
                    translate
                    [value]="reason.id"
                    *ngFor="let reason of service.ReasonList"
                    >{{ reason.name }}
                  </ng-option>
                </ng-select>
                <div class="mt-2 comment">
                  <textarea
                    class="form-control customize-textbox"
                    cols="30"
                    rows="5"
                    formControlName="reasonText"
                  ></textarea>
                </div>
                
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="af-form-group">
              <label translate>lblDescriptionOfWork</label>
              <div class="lbl-info">
                <textarea
                    class="form-control customize-textbox"
                    cols="30"
                    rows="5"
                    formControlName="comment"
                    style="height: 152px;"
                  ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="comment-main-container" *ngIf="diagnoseItems.length > 0">
          <div class="comment-section">
            <div class="comment-inner-section">
              <div class="right-button">
                <button type="button" title="CopyAll" (click)="copyTextDetail(getCopyText('diagnoseText'))">
                  <em class="fas fa-copy fa-lg"></em>
                </button>
              </div>
            </div>
            <div class="comment-inner-section">
              <div class="right-button">
                <button type="button" title="CopyAll" (click)="copyTextDetail(getCopyText('causeText'))">
                  <em class="fas fa-copy fa-lg"></em>
                </button>
              </div>
            </div>
            <div class="comment-inner-section">
              <div class="right-button">
                <button type="button" title="CopyAll" (click)="copyTextDetail(getCopyText('reasonText'))">
                  <em class="fas fa-copy fa-lg"></em>
                </button>
              </div>
            </div>
            <div class="comment-inner-section">
              <div class="right-button">
                <button type="button" title="CopyAll" (click)="copyTextDetail(getCopyText('comment'))">
                  <em class="fas fa-copy fa-lg"></em>
                </button>
              </div>
            </div>
          </div>
          <div class="comment-section" *ngFor="let item of diagnoseItems">
            <div class="comment-inner-section">
              <div class="comment-edit-btn">
                  <button type="button" (click)="editItem(item)" title="Edit"
                  [disabled]="item.createdUser.toLowerCase() != userDetails.id.toLowerCase()">
                    <em class="fas fa-pencil-alt fa-lg"></em>
                  </button>
              </div>
              <span style="font-weight: bold;">{{item.createdBy + ' - ' + item.createdDate}}</span>
              <br>
              <span class="word-break"> {{item.diagnoseText}}</span>
            </div>
            <div class="comment-inner-section">
              <span style="font-weight: bold;">{{item.createdBy + ' - ' + item.createdDate}}</span>
              <br>
              <span class="word-break"> {{item.causeText}}</span>
            </div>
            <div class="comment-inner-section">
              <span style="font-weight: bold;">{{item.createdBy + ' - ' + item.createdDate}}</span>
              <br>
              <span class="word-break"> {{item.reasonText}}</span>
            </div>
            <div class="comment-inner-section">
              <span style="font-weight: bold;">{{item.createdBy + ' - ' + item.createdDate}}</span>
              <br>
              <span class="word-break"> {{item.comment}}</span>
            </div>
          </div>

        </div>
        
        <div class="col-12">
          <div class="col-6 col-lg-3">
            <div class="af-form-group">
              <label translate>lblCustomerInformation</label>
              <div class="lbl-info">
                <input
                  type="text"
                  name="text"
                  formControlName="customerInfo"
                  [(ngModel)]="demandDetails.customerInfo"
                  class="form-control"
                  style="padding-right: 23px"
                />
                <a
                  class="btn btn-link ml-2 btn-copy-input"
                  (click)="copyTextDetail(demandDetails.customerInfo)"
                  placement="top"
                  ngbTooltip="{{ 'lblCopy' | translate }}"
                  aria-label="Center Align"
                  [class.disabled]="!demandDetails.customerInfo"
                >
                  <em class="fas fa-copy fa-lg"></em>
                </a>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="af-form-group">
              <label translate>lblCauseCode</label>
              <div class="lbl-info">
                <input
                  type="text"
                  name="text"
                  formControlName="batteryTesterCodes"
                  [(ngModel)]="demandDetails.batteryTesterCodes"
                  class="form-control"
                  style="padding-right: 23px"
                />
                <a
                  class="btn btn-link ml-2 btn-copy-input"
                  (click)="copyTextDetail(demandDetails.batteryTesterCodes)"
                  placement="top"
                  ngbTooltip="{{ 'lblCopy' | translate }}"
                  aria-label="Center Align"
                  [class.disabled]="!demandDetails.batteryTesterCodes"
                >
                  <em class="fas fa-copy fa-lg"></em>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100"></div>

        <div class="col-12 mt-3 mb15" *ngIf="!(isSST && isBrandNissan)">
          <h4 class="title16 border-bottom-black pb-2" translate>
            lblDiagnoseCheckList
          </h4>
        </div>
        <ng-container *ngIf="c && diagnosecheckList?.length>0 && !(isSST && isBrandNissan); else load_else">
          <div *ngFor="let chk of diagnosecheckList" class="col-12 col-lg-12">
            <h4 *ngIf="chk.showTitle" class="titleS16 text-bold mb-3">
              {{ chk.subCheckListTitle }}
            </h4>
            <div *ngFor="let chkItem of chk.checkListItems; let i = index">
              <div
                class="cst-lbl-val mb-3 row"
                *ngIf="chkItem.isQuestionActive"
              >
                <label
                  class="diagnose-field col-md-3 mt-2"
                  for="{{ chkItem.id }}"
                  id="lbl{{ chkItem.id }}"
                  >{{ chkItem.subCheckListItemTitle }}</label
                >
                <div
                  class="diagnose-val nombt-report widthauto floatnone col-md-9"
                >
                  <div class="row d-md-flex checklist-input-direction">
                    <div
                      class="col-4 d-flex align-items-center"
                      *ngIf="
                        chkItem.checkListType === 2 ||
                        chkItem.checkListType === 3 ||
                        chkItem.checkListType === 5 ||
                        chkItem.checkListType === 7
                      "
                    >
                      <input
                        type="text"
                        name="fname"
                        [value]="chkItem.textBoxValue"
                        id="checklistDiagnose_{{
                          chkItem.appointmentDemandNo
                        }}_{{ chkItem.id }}"
                        (change)="
                          updateDynamicFieldValue(
                            chkItem.id,
                            $event.target.value,
                            'textAnswer'
                          )
                        "
                        class="form-control form-control-sm"
                        maxlength="1000"
                      />
                      <button
                        *ngIf="chkItem.textBoxValue"
                        class="btn btn-link ml-2"
                        (click)="copyTextDetail(chkItem.textBoxValue)"
                        placement="top"
                        ngbTooltip="{{ 'lblCopy' | translate }}"
                        aria-label="Center Align"
                      >
                        <em class="fas fa-copy fa-lg"></em>
                      </button>
                    </div>
                    <div class="checklist-input">
                      <div
                        class="form-check-inline"
                        *ngIf="chkItem.checkListItemType.length > 0"
                      >
                        <div
                          class="form-check pl-0"
                          *ngFor="let cbTitle of chkItem.checkListItemType"
                        >
                          <label
                            class="mr10"
                            *ngIf="
                              (cbTitle.checkboxTitle != null && !isSSM) || isSSM
                            "
                          >
                            <input
                              type="checkbox"
                              name="cbTitle.checkboxTitle"
                              value="cbTitle.checkboxTitle"
                              [ngClass]="{ addedvalue: cbTitle.checkBoxValue }"
                              (change)="
                                updateDynamicFieldValue(
                                  cbTitle.id,
                                  $event.target.checked,
                                  'checkAnswer'
                                )
                              "
                              [checked]="cbTitle.checkBoxValue"
                            />
                            {{ cbTitle.checkboxTitle }}
                          </label>
                        </div>
                      </div>
                      <div
                        class="form-check-inline"
                        *ngIf="chkItem.checkListRadioItemType.length > 0"
                      >
                        <div
                          *ngFor="let cbTitle of chkItem.checkListRadioItemType"
                        >
                          <label
                            class="mr10"
                            *ngIf="cbTitle.radioButtonTitle != null"
                          >
                            <input
                              type="radio"
                              value="cbTitle.radioButtonValue"
                              [checked]="cbTitle.radioButtonValue"
                              [name]="chkItem.subCheckListItemTitle"
                              [ngClass]="{
                                addedvalue: cbTitle.radioButtonValue
                              }"
                              (change)="
                                updateDynamicFieldValue(
                                  cbTitle.id,
                                  $event.target.checked,
                                  'radioAnswer'
                                )
                              "
                              class="radio-custom"
                            />
                            {{ cbTitle.radioButtonTitle }}
                          </label>
                        </div>
                      </div>
                      <div>
                        <ng-container *ngIf="chkItem.makeCameraAvailable">
                          <button
                            type="button"
                            class="relative pl-0"
                            readonly
                            aria-label="Center Align"
                          >
                            <em class="fas fa-upload"></em>
                            <span class="badge badge-primary top background">{{
                              chkItem.fileCount
                            }}</span>
                          </button>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #load_else *ngIf="!(isSST && isBrandNissan)">
          <p class="no-record" translate>lblNoCheckListFound</p>
        </ng-template>
        <div
          class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15"
        >
         <button type="submit" class="btn btn-primary btn-lg mr-sm-2" 
            [disabled]="!editDwoDiagnoseForm.valid || isFormEmpty()" translate aria-label="Center Align">
            {{ getButtonLabel() | translate }}
          </button>
          <a (click)="Cancelform()" class="btn btn-secondary btn-lg" translate
            >lblCancel</a
          >
        </div>
      </div>
    </form>
  </div>
</div>
